import { Alert, Button, Group, SimpleGrid, Stack, Text } from '@mantine/core';
import { DatePickerInput } from '@mantine/dates';
import { IconPrinter } from '@tabler/icons-react';
import { useState } from 'react';
import { api } from '../api/odjemalec';
import { NapakaApi, sporocilo } from '../api/napaka';
import { odpriPdf } from '../api/pdf';
import { Kartica } from '../postavitev/Podatki';
import { GlavaZaslona, ZaslonSeznama } from '../seznam/Seznam';

const danes = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
};

/**
 * Zaključek dneva: blagajniški dnevnik gotovinskih računov za
 * vsak dan obdobja. Strežnik vrne en PDF z enim poročilom na dan (brskalnik več datotek naenkrat ne odpre).
 */
export function ZakljucekDneva() {
  const [od, setOd] = useState<string | null>(danes());
  const [doDatuma, setDo] = useState<string | null>(danes());
  const [napake, setNapake] = useState<Record<string, string>>({});
  const [napaka, setNapaka] = useState<string | null>(null);
  const [dela, setDela] = useState(false);

  const ustvari = async () => {
    setDela(true);
    setNapake({});
    setNapaka(null);
    try {
      await odpriPdf(
        api.GET('/api/porocila/zakljucek-dneva/obdobje/pdf', {
          params: { query: { od: od ?? undefined, do: doDatuma ?? undefined } },
          parseAs: 'blob',
        }),
      );
    } catch (e) {
      if (e instanceof NapakaApi && Object.keys(e.polja).length > 0) {
        setNapake(e.polja);
      } else {
        setNapaka(sporocilo(e));
      }
    } finally {
      setDela(false);
    }
  };

  return (
    <ZaslonSeznama>
      <GlavaZaslona
        naslov="Zaključek dneva"
        opis="Izpis dnevnih izkupičkov (blagajniški dnevnik gotovinskih računov)."
        pomoc="zakljucek-dneva"
      />
      <Kartica naslov="Obdobje">
        <Stack gap="sm" maw={520}>
          <Text size="sm" c="dimmed">
            Za vsak dan v izbranem obdobju se ustvari eno poročilo, vsa v enem PDF (največ 62 dni).
          </Text>
          <SimpleGrid cols={{ base: 1, xs: 2 }} spacing="sm">
            <DatePickerInput label="Začetek" value={od} onChange={setOd} valueFormat="D. M. YYYY" error={napake.od} />
            <DatePickerInput
              label="Konec"
              value={doDatuma}
              onChange={setDo}
              valueFormat="D. M. YYYY"
              error={napake.do}
            />
          </SimpleGrid>
          {napaka && (
            <Alert color="red" variant="light" role="alert">
              {napaka}
            </Alert>
          )}
          <Group justify="flex-end">
            <Button leftSection={<IconPrinter size={18} />} onClick={() => void ustvari()} loading={dela}>
              Ustvari poročila
            </Button>
          </Group>
        </Stack>
      </Kartica>
    </ZaslonSeznama>
  );
}
